<template>
	<div>
	<div class="wd-theme-back">
		<Top></Top>
		<div class="wd-container" v-if="wddata != ''">
			<div class="wd-text-center">
				<h2>评价订单</h2>
				<div>
					<span class="wd-theme-999">订单号：</span>
					<span class="wd-theme-333">{{ wddata.listseqno }}</span>
					<span class="wd-theme-999 wd-m-l-20">{{ wddata.listdate }}</span>
				</div>
			</div>
			<div class="">
				<el-row class="wd-p-20 wd-m-t-20 wd-theme-back-fff">
					<el-col :span="8" class="wd-border-right wd-flex wd-p-r-10">
						<div class="wd-img-80 wd-row-noshrink wd-m-r-20"><el-image :src="$wdpicurl('', true)" class="wd-border-round"></el-image></div>
						<div class="wd-row-grow wd-col-top">
							<div class=" wd-lh-20">
								<span class="wd-font-16 wd-font-bold">{{ wddata.stockname }}</span>
							</div>
							<div class="wd-flex wd-row-between wd-theme-999 wd-m-r-30">
								<div>
									<p>综合</p>
									<p class="wd-theme wd-font-bold wd-font-16">{{ $weidajs.numberFixed(wddata.rateall, 0) }}</p>
								</div>
								<!-- <div>
									<p>商品</p>
									<p class="">4.0</p>
								</div> -->
								<div>
									<p>服务</p>
									<p class="wd-theme wd-font-bold wd-font-16">{{ $weidajs.numberFixed(wddata.rate1, 0) }}</p>
								</div>
								<div>
									<p>物流</p>
									<p class="wd-theme wd-font-bold wd-font-16">{{ $weidajs.numberFixed(wddata.rate2, 0) }}</p>
								</div>
							</div>
						</div>
					</el-col>
					<el-col :span="16" class=" wd-theme-666 wd-p-l-20">
						<!-- <div class="wd-flex wd-m-b-20">
							<div class="wd-width-100"><span>商品综合评价</span></div>
							<el-rate v-model="shop_goodsrate"  :colors="['#FF4C4C','#FF4C4C','#FF4C4C']"></el-rate>
						</div> -->
						<div class="wd-flex wd-m-t-20 wd-m-b-20">
							<div class="wd-width-100"><span>店家服务态度</span></div>
							<el-rate v-model="shop_shoprate" :colors="['#FF4C4C', '#FF4C4C', '#FF4C4C']"></el-rate>
						</div>
						<div class="wd-flex">
							<div class="wd-width-100"><span>快递配送速度</span></div>
							<el-rate v-model="shop_expressrate" :colors="['#FF4C4C', '#FF4C4C', '#FF4C4C']"></el-rate>
						</div>
					</el-col>
				</el-row>
				<el-row class="wd-p-20 wd-m-t-10 wd-theme-back-fff" v-for="(item, index) in wddata.posdetail" :key="index">
					<el-col :span="8" class="wd-border-right wd-p-r-10 wd-flex wd-row-between wd-col-top">
						<div class="wd-width-100 wd-cursor wd-m-auto wd-row-noshrink">
							<el-image :src="$wdpicurl(item.pic1)" @click="gotogoodsdetail(item.goodsid, item.name)"></el-image>
						</div>
						<div class="wd-row-grow wd-m-l-20">
							<div class="wd-cursor  wd-theme-666" @click="gotogoodsdetail(item.goodsid, item.name)">{{ item.name }}</div>
							<div class="wd-font-16 wd-font-bold wd-m-t-20 wd-theme">¥{{ item.retailprice | amountFormatter }}</div>
						</div>
					</el-col>
					<el-col :span="16" class="wd-p-l-20">
						<div class="wd-flex">
							<div class="wd-width-100">商品评分</div>
							<div><el-rate v-model="item.goodsrate" :colors="['#FF4C4C', '#FF4C4C', '#FF4C4C']"></el-rate></div>
						</div>
						<div class="wd-flex wd-m-t-20">
							<div class="wd-width-100">评价晒单</div>
							<div class="wd-row-grow">
								<el-input
									:rows="4"
									v-model="item.memo"
									type="textarea"
									placeholder="分享使用心得,给小伙伴们一个美好的建议"
									maxlength="100"
									show-word-limit
									:autosize="{ minRows: 2, maxRows: 6}"
								></el-input>
							</div>
						</div>
						<div class="wd-m-t-20">
							<!-- <div v-for="(picitem,picindex) in item.filelist" :key="picindex">
								<img class="el-upload-list__item-thumbnail" :src="$wdpicurl(picitem)" alt="" />
								<span class="el-upload-list__item-actions">
									<span class="el-upload-list__item-preview" @click="imgpreview(index,picindex)"><i class="el-icon-zoom-in"></i></span>
									<span class="el-upload-list__item-delete" @click="imgdelete(index,picindex)"><i class="el-icon-delete"></i></span>
								</span>
							</div> -->
							<el-upload action="#" :multiple="false" list-type="picture-card" :limit="limitpic" :http-request="param => aupimg(param, index)" :on-exceed="exceed" :on-preview="imgpreview" :on-remove="(file,filelist)=>imgdelete(file,filelist,index)" accept="image/jpeg,image/png,image/jpg">
								<i slot="default" class="el-icon-plus"></i>
							</el-upload>
							<div class="wd-theme-999 wd-m-t-5">可上传{{limitpic}}张图片</div>
							<!-- <div v-if="item.filelist!=''">共{{ item.filelist.length}}张，还能上传{{ limitpic - item.filelist.length }}张</div>
							<div v-else>共0张，还能上传{{limitpic}}张</div> -->
						</div>
					</el-col>
				</el-row>
				<div class="wd-m-t-10 wd-theme-back-fff wd-text-center">
					<div class="wd-p-20">
						<el-button type="primary" class="wd-p-l-50 wd-p-r-50" @click="save" :loading="opting">发表评论</el-button>
						<el-checkbox v-model="hidename" class="wd-m-l-20">匿名评价</el-checkbox>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
		<el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
	</div>
	</div>
</template>

<script>
import Top from '@/components/layout/Top4.vue';
import Footer from '@/components/layout/Footer.vue';
import {mapState} from "vuex"
export default {
	name: 'Comment',
	computed:{
		...mapState(["logininfo"])
	},
	components: {
		Top,
		Footer
	},
	data() {
		return {
			wddata: [],
			shop_goodsrate: 0,
			shop_shoprate: 0,
			shop_expressrate: 0,
			hidename: false,
			memo: '',
			posid: '',
			listseqno: '',
			dialogImageUrl: '',
			dialogVisible: false,
			limitpic:6,
			opting:false
		};
	},
	methods: {
		save(){
			// if (parseInt(this.shop_goodsrate)==0){
			// 	this.$wd_toast('商品综合评价未评分', 'error');
			// 	return;
			// }
			this.opting=true;
			if (parseInt(this.shop_shoprate)==0){
				this.$wd_toast('店家服务态度未评分', 'error');
				this.opting=false;
				return;
			}
			if (parseInt(this.shop_expressrate)==0){
				this.$wd_toast('店家服务态度未评分', 'error');
				this.opting=false;
				return;
			}
			var detail=[];
			for (var i = 0; i < this.wddata.posdetail.length; i++) {
				var dd=this.wddata.posdetail[i];
				if (parseInt(dd.goodsrate)==0){
					this.$wd_toast('商品['+dd.name+']未评分', 'error');
					this.opting=false;
					return;
				}
				var pic1="",pic2="",pic3="",pic4="",pic5="",pic6="";
				var fl=dd.filelist;
				if (!this.$weidajs.isEmpty(fl)){
					for (var j = 0; j < fl.length; j++) {
						if (j===0){
							pic1=fl[j].url;
						}else if (j===1){
							pic2=fl[j].url;
						}else if (j===2){
							pic3=fl[j].url;
						}else if (j===3){
							pic4=fl[j].url;
						}else if (j===4){
							pic5=fl[j].url;
						}else if (j===5){
							pic6=fl[j].url;
						}
					}
				}
				var memo="";
				if (!this.$weidajs.isEmpty(dd.memo)){
					memo=dd.memo;
				}
				detail.push({goodsid:dd.goodsid,pic1:pic1,pic2:pic2,pic3:pic3,pic4:pic4,pic5:pic5,pic6:pic6,rate:dd.goodsrate,detailid:dd.id,comment:memo});
			}
			
			var indata={
				nickname:this.logininfo.myinfo.nickname,
				shoprate:this.shop_shoprate,
				servicerate:this.shop_expressrate,
				detail:detail,
				hidename:this.hidename
			}
			this.$wd_request("mem_comment_save_bat",indata)
			.then(()=>{
				this.$wd_toast("评价成功");
				this.$router.go(-1);
			})
			.catch(data=>{
				this.opting=false;
				this.$wd_toast(data.msg,"error");
			})
		},
		exceed(){
			this.$wd_toast('只能上传'+this.limitpic+'张图片', 'error');
			return;
		},
		imgpreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		imgdelete(file,b,idx) {
			var fl=this.wddata.posdetail[idx].filelist;
			if (this.$weidajs.isEmpty(fl)){
				return;
			}
			var uid=file.uid;
			for (var i = 0; i < fl.length; i++) {
				if (uid===fl[i].file){
					fl.splice(i,1);
					break;
				}
			}
		},
		getimgnum(idx){
			var fl=this.wddata.posdetail[idx].filelist;
			if (this.$weidajs.isEmpty(fl)){
				return 0;
			}
			return fl.length;
		},
		aupimg(param, idx) {
			var fl=this.wddata.posdetail[idx].filelist;
			if (!this.$weidajs.isEmpty(fl)){
				if (fl.length >= 2) {
					this.$wd_toast('只能上传'+this.limitpic+'张图片', 'error');
					return;
				}
			}
			var file = param.file;
			this.$wdupimg(file).then(data => {
				if (this.$weidajs.isEmpty(fl)){
					var aaaa=[];
					aaaa.push({file:file.uid,url:data.value});
					this.wddata.posdetail[idx].filelist=aaaa;
				}else{
					this.wddata.posdetail[idx].filelist.push({file:file.uid,url:data.value});
				}
			})
			.catch(()=>{});
		},
		loaddata() {
			this.wddata = [];
			let indata = {
				posid: this.posid
			};
			this.$wd_request('memcomment_orderlist', indata, true)
				.then(data => {
					var dt = data.value;
					for (var i = 0; i < dt.length; i++) {
						dt[i].goodsrate = 0;
						dt[i].memo = '';
						dt[i].filelist = [];
					}
					this.wddata = dt;
				})
				.catch(() => {
					console.log('nodata');
				});
		},
		gotogoodsdetail(goodsid, goodsname) {
			this.$router.push({
				name: 'Goodsinfo',
				query: {
					goodsid: goodsid,
					goodsname: goodsname
				}
			});
		}
	},
	activated() {
		var params = this.$route.query;
		let posid = params.posid || '';
		this.listseqno = params.orderno || '';
		if (posid !== '' && posid !== this.posid && this.listseqno !== '') {
			this.posid = posid;
			this.loaddata();
		}
	}
};
</script>

<style lang="scss" scoped>
::v-deep .el-upload--picture-card {
	width: 80px;
	height: 80px;
	line-height: 86px;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item{
	width: 80px;
	height: 80px;
}
</style>
